
// This could be made more universal, but it meets the current needs.
export const generateLoginPageWithReturnUrlLink = (baseLoginPageUrl, masterItemNumber, addToList = false, addToCart = false) => {
    if (!window?.location) return baseLoginPageUrl;

    let returnParams = new URLSearchParams(window.location.search);

    if (!!masterItemNumber) returnParams.set('min', masterItemNumber);

    if (addToList)
        returnParams.set('addtolist', 'true');
    if (addToCart)
        returnParams.set('addtocart', 'true');

    return baseLoginPageUrl + "?ReturnUrl=" + encodeURIComponent(window.location.pathname + "?" + returnParams.toString());
}